module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/5-5d9a54e89ecf37a6451b89b65eb1eb79.jpg";